import { makeAsyncReducerHandlers } from '../../helpers';
import { QuestionnairesActionTypes } from '../../actions/types';
import { RequestStatus } from '../../enums';

const fetchQuestionnaireByCustomerId = makeAsyncReducerHandlers(
  QuestionnairesActionTypes.fetchQuestionnaireByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.questionnaire],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateQuestionnaireByCustomer = makeAsyncReducerHandlers(
  QuestionnairesActionTypes.updateQuestionnaireByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.questionnaire],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getQuestionnaireByProjectId = makeAsyncReducerHandlers(
  QuestionnairesActionTypes.getQuestionnaireByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.questionnaire ? [action.payload.questionnaire] : state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const createQuestionnaire = makeAsyncReducerHandlers(
  QuestionnairesActionTypes.createQuestionnaire,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.questionnaire],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  fetchQuestionnaireByCustomerId,
  updateQuestionnaireByCustomer,
  getQuestionnaireByProjectId,
  createQuestionnaire,
};
